module.exports = __webpack_public_path__ + "img/ums-role.5d9187f9.svg";